export enum BridgeEvmRouterType {
  fastest = 'fastest',
  lowFee = 'lowFee',
  highReturn = 'highReturn',
}
